export default __webpack_public_path__ + "static/media/AntyLucy_2.f9813044.jpg";